export { AvatarStack } from './src/AvatarStack';
export type { AvatarItem, AvatarStackProps } from './src/AvatarStack.types';
